/** Per-language presentation: names, theme class (course colours) and speech locale. */

export interface LanguageInfo {
  lang: string;
  titleRu: string;
  /** Lower-case adjective for sentences such as «учитель (китайский язык)». */
  adjectiveRu: string;
  theme: 'th-cn' | 'th-tr' | 'th-en';
  speechLang: string;
}

export const LANGUAGES: readonly LanguageInfo[] = [
  { lang: 'zh', titleRu: 'Китайский', adjectiveRu: 'китайский', theme: 'th-cn', speechLang: 'zh-CN' },
  { lang: 'en', titleRu: 'Английский', adjectiveRu: 'английский', theme: 'th-en', speechLang: 'en-US' },
  { lang: 'tr', titleRu: 'Турецкий', adjectiveRu: 'турецкий', theme: 'th-tr', speechLang: 'tr-TR' },
];

export function languageInfo(lang: string | undefined): LanguageInfo {
  return LANGUAGES.find((l) => l.lang === lang) ?? LANGUAGES[0]!;
}
